import React from 'react';
import round from 'utils/round';

export default class DifferenceIndicator extends React.PureComponent {
  render() {
    const {measure} = this.props;
    return isNaN(measure) ? null : measure >= 0 ? (
      <span className="difference positive">+{round(measure)}%</span>
    ) : (
      <span className="difference negative">{round(measure)}%</span>
    );
  }
}
